import React from 'react'
import PropTypes from 'prop-types'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { meta } from '../../content_option'

const PageLayout = ({ 
  title, 
  description = meta.description, 
  children, 
  className = '',
  id = ''
}) => {
  const pageTitle = title ? `${title} | ${meta.title}` : meta.title

  return (
    <HelmetProvider>
      <section id={id} className={className}>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{pageTitle}</title>
          <meta name='description' content={description} />
        </Helmet>
        {children}
      </section>
    </HelmetProvider>
  )
}

PageLayout.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string
}

export default PageLayout